// 統一 protobufjs Root — 載入後端權威多檔（Common / Slot001FaFaCat / Gateway）。
// 以 ?raw 取得各 .proto 文字後解析進同一個 root；跨檔型別以完整名稱解析，
// 故移除 import 行並自行注入 google.protobuf.Any（protobufjs 同步 parse 不自動解析 import）。
import * as protobuf from 'protobufjs'
import commonText from '../../../../proto/common.proto?raw'
import commonCmdText from '../../../../proto/common_cmd.proto?raw'
import slotdefText from '../../../../proto/slotdef.proto?raw'
import gatewayCmdText from '../../../../proto/gateway_cmd.proto?raw'
import gatewayLoginText from '../../../../proto/gateway_login.proto?raw'
import gatewayGameInfoText from '../../../../proto/gateway_gameinfo.proto?raw'
import gatewayGetBalanceText from '../../../../proto/gateway_getbalance.proto?raw'
import gatewayDeviceInfoText from '../../../../proto/gateway_deviceinfo.proto?raw'

// google.protobuf.Any 的 wire 定義（ClientSpinCmd.SpinData / SpinResult.SlotResult 使用）。
const ANY_PROTO = `
syntax = "proto3";
package google.protobuf;
message Any { string type_url = 1; bytes value = 2; }
`

const SOURCES = [
  ANY_PROTO,
  commonText,
  commonCmdText,
  slotdefText,
  gatewayLoginText,
  gatewayGameInfoText,
  gatewayGetBalanceText,
  gatewayDeviceInfoText,
  gatewayCmdText,
]

function stripImports(source: string): string {
  return source.replace(/^[ \t]*import[ \t]+["'][^"']+["'][ \t]*;[ \t]*$/gm, '')
}

let cached: protobuf.Root | null = null

function root(): protobuf.Root {
  if (cached === null) {
    const built = new protobuf.Root()
    for (const source of SOURCES) {
      // keepCase 保留欄位原始大小寫（Cmd / TotalBet / type_url …），與程式存取一致。
      protobuf.parse(stripImports(source), built, { keepCase: true })
    }
    built.resolveAll()
    cached = built
  }
  return cached
}

export function lookupType(fullName: string): protobuf.Type {
  return root().lookupType(fullName)
}
